<template>
	<BaseCmsPage v-slot="{page}">
		<CmsIntroContainer :page="page">
			<template #h1>
				<h1 v-if="page?.seo_h1">{{ page.seo_h1 }}</h1>
			</template>
		</CmsIntroContainer>


		<section class="main">
			<div class="wider-wrapper">
				<div class="main-content">
					<div class="cms-content">
						<template v-if="page?.code == 'webshop_terms' || page?.id == '20'">
							<BaseCmsNav code="cms_terms" v-slot="{items}">
								<ul class="cms-terms-menu" v-if="items?.length">
									<li v-for="item in items" :key="item.id">
										<NuxtLink :to="item.url">
											{{ item.title }}
										</NuxtLink>
									</li>
								</ul>
							</BaseCmsNav>
						</template>

						<div v-if="page?.content" v-html="wrapInnerBtn(page.content)" v-interpolation />

						<template v-if="page?.code == 'webshop_terms' || page?.id == '15' && page?.content_pdf_upload_path">
							<a class="btn btn-download btn-download-pdf btn-download-terms" :href="page?.content_pdf_upload_path" target="_blank"><BaseCmsLabel code="download_terms_pdf" /></a>
						</template>

						<CmsShare />
					</div>
				</div>
				
				<CmsSidebar />
			</div>
		</section>

		<CmsBenefits />
	</BaseCmsPage>
</template>

<style lang="less">
</style>